









































































































































































































import { RootState } from "@/store";
import moment from "moment";
import Vue from "vue";
import { mapGetters, mapState } from "vuex";

import DateMomentTooltip from "@/components/DateMomentTooltip.vue";
import { formatSeconds } from "@/utility/Formatter";

import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { CReqExecutionResultEnum } from "@/model/communication/CReqExecutionResultEnum";
import { GetAgentTunnelServiceConnectedTimeCommand } from "@/model/communication/remoteLink/GetAgentTunnelServiceConnectedTimeCommand";
import { GetAgentTunnelServiceConnectedTimeResData } from "@/model/communication/remoteLink/GetAgentTunnelServiceConnectedTimeResData";
import { StartAgentTunnelSessionCommand } from "@/model/communication/remoteLink/StartAgentTunnelSessionCommand";
import { StartAgentTunnelSessionResData } from "@/model/communication/remoteLink/StartAgentTunnelSessionResData";
import { StopAgentTunnelSessionCommand } from "@/model/communication/remoteLink/StopAgentTunnelSessionCommand";
import { TunnelProtocolEnum, TunnelProtocolEnumToProtocolName, TunnelProtocolEnumToString, TunnelProtocolToPort } from "@/model/data/enums/TunnelProtocolEnum";
import { InstallationRemoteLinkStatus } from "@/model/data/remoteLink/InstallationRemoteLinkStatus";

export default Vue.extend({
    components: { DateMomentTooltip },
    props: {
        installation: Object as () => InstallationRemoteLinkStatus,
        loading: Boolean,
    },
    data() {
        return {
            moment,
            canCopy: window.isSecureContext,
            startSessionLoading: false,
            stopSessionLoading: false,
            localSessions: this.installation.cserviceSession,
            TunnelProtocolEnum,
            alertType: "",
            errorMessage: "",
            showAlert: false,
            loadingChart: false,
            dateListString: [],
            seriesConnectedTime: [],
            selectedMachines: [],
            copyIcon: Array(10).fill("copy"),
            circleIcon: Array(10).fill("circle"),
            cursorIcon: "i-cursor",
        };
    },
    computed: {
        ...mapState({
            userTheme: (state: RootState) => state.authMod.currentUser.userConfig.theme,
            authUser: (state: RootState) => state.authMod.currentUser,
            startupData: (state: RootState) => state.application.startupData,
        }),
        ...mapGetters(["userDateFormat"]),
        chartAgentTunnelServiceConnectedTime() {
            return {
                options: {
                    theme: {
                        mode: this.userTheme,
                    },
                    chart: {
                        type: "bar",
                        stacked: true,
                        animations: {
                            enabled: false,
                        },
                        zoom: {
                            enabled: false,
                        },
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: false,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    xaxis: {
                        type: "category",
                        categories: this.dateListString,
                        tickPlacement: "on",
                    },
                    yaxis: {
                        labels: {
                            formatter: (value) => {
                                if (value != null) {
                                    return this.formatSeconds(value, true);
                                }
                                return null;
                            },
                        },
                    },
                    tooltip: {
                        y: {
                            formatter: (value) => this.formatSeconds(value),
                        },
                    },
                },
                series: this.seriesConnectedTime,
            };
        },
        host() {
            if (this.startupData && this.startupData.currentIp) return this.startupData.currentIp;
            return location.host;
        },
        cserviceUrls() {
            let urls = new Map<string, string>();
            if (this.localSessions && this.localSessions.length) {
                let ports = new Map<string, Array<number>>();
                this.localSessions.forEach((session) => {
                    if (!ports.get(session.portSerialNumber)) ports.set(session.portSerialNumber, [session.port]);
                    else ports.get(session.portSerialNumber).push(session.port);
                });
                ports.forEach((ports, serialNumber) => {
                    let machineModel = "";
                    if (this.installation && this.installation.machines && this.installation.machines.filter((m) => m.serialNumber == serialNumber))
                        machineModel = this.installation.machines.filter((m) => m.serialNumber == serialNumber)[0].model;
                    let payload = {
                        ports: ports,
                        sessionStartedAt: this.localSessions[0].startDate,
                        installationName: this.installationName,
                        user: this.authUser.name,
                        machineModel: machineModel,
                    };
                    urls.set(serialNumber, `cservice://${this.host}?payload=${btoa(JSON.stringify(payload))}`);
                });
            }
            return urls;
        },
        agentInfo() {
            if (this.installation) return this.installation.agentInfo;
            return null;
        },
        sessions() {
            if (this.installation) return this.installation.cserviceSession;
            return [];
        },
        installationName() {
            if (this.installation) return this.installation.name;
            return "";
        },
    },
    watch: {
        installation: {
            handler() {
                this.showAlert = false;
                this.localSessions = this.sessions;
                this.selectedMachines = [];
                this.startSessionLoading = false;
                this.stopSessionLoading = false;
                this.getAgentTunnelServiceConnectedTime();
            },
            immediate: true,
            deep: true,
        },
        sessions: {
            handler(value) {
                this.localSessions = value;
            },
            deep: true,
        },
    },
    methods: {
        formatSeconds,
        TunnelProtocolEnumToString,
        TunnelProtocolToPort,
        TunnelProtocolEnumToProtocolName,
        formatLongUrl(url) {
            return `${url.substring(0, 50)}...`;
        },
        async copy(type: string, index: number, serialNumber: string) {
            switch (type) {
                case "endpoint":
                    await navigator.clipboard.writeText(`${this.host}:${this.localSession.port}`);
                    break;
                case "host":
                    await navigator.clipboard.writeText(this.host);
                    this.cursorIcon = "check";
                    setTimeout(() => {
                        this.cursorIcon = "i-cursor";
                    }, 1000);
                    break;
                case "port":
                    await navigator.clipboard.writeText(this.localSessions[index].port);
                    this.circleIcon.splice(index, 1, "check");
                    setTimeout(() => {
                        this.circleIcon.splice(index, 1, "circle");
                    }, 1000);
                    break;
                case "url":
                    await navigator.clipboard.writeText(this.cserviceUrls.get(serialNumber));
                    this.copyIcon.splice(index, 1, "check");
                    setTimeout(() => {
                        this.copyIcon.splice(index, 1, "copy");
                    }, 1000);
                    break;
            }
        },
        openUrl(serialNumber: string) {
            window.open(this.cserviceUrls.get(serialNumber), "_blank");
        },
        async startSession() {
            this.showAlert = false;
            this.startSessionLoading = true;
            try {
                let response: StartAgentTunnelSessionResData = await new StartAgentTunnelSessionCommand(
                    this.installationName,
                    this.selectedMachines,
                    TunnelProtocolToPort(TunnelProtocolEnum.CService),
                    false
                ).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString.toLowerCase() == "success") {
                    this.localSessions = response.newSessions;
                    this.$emit("data-reload");
                } else {
                    throw response.message;
                }
            } catch (error) {
                this.showAlert = true;
                switch (error) {
                    case CReqExecutionResultEnum.AgentOffline:
                        this.errorMessage = this.$t("device_status.agentOfflineForInstallation", { task: "connect" });
                        this.alertType = "warning";
                        break;
                    case CReqExecutionResultEnum.AgentNotInstalled:
                        this.errorMessage = this.$t("device_status.agentNotInstalled", { task: "connect" });
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.DeviceLocked:
                        this.errorMessage = this.$t("device_status.agentLocked", { task: "connect" });
                        this.alertType = "warning";
                        break;
                    case CReqExecutionResultEnum.OperationNotAvailable:
                        this.errorMessage = this.$t("device_status.operationNotAvailable", { task: "connection" });
                        this.alertType = "info";
                        break;
                    case CReqExecutionResultEnum.ServerError:
                        this.errorMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.InvalidRequest:
                        this.errorMessage = this.$t("remoteLink.invalidVersion");
                        this.alertType = "error";
                        break;
                    default:
                        console.error("Something went wrong sending Connect request ", error);
                        this.errorMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        break;
                }
            }
            this.startSessionLoading = false;
        },
        async stopSession() {
            this.stopSessionLoading = true;
            this.showAlert = false;
            try {
                let response: ApiGenericResponse = await new StopAgentTunnelSessionCommand(this.installationName, TunnelProtocolToPort(TunnelProtocolEnum.CService)).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString.toLowerCase() == "success") {
                    this.localSessions = null;
                    this.$emit("data-reload");
                    await this.getAgentTunnelServiceConnectedTime();
                } else {
                    throw response.message;
                }
            } catch (error) {
                this.showAlert = true;
                switch (error) {
                    case CReqExecutionResultEnum.AgentOffline:
                        this.rebootErrorMessage = this.$t("device_status.agentOfflineForInstallation", { task: "disconnect" });
                        this.alertType = "warning";
                        break;
                    case CReqExecutionResultEnum.AgentNotInstalled:
                        this.rebootErrorMessage = this.$t("device_status.agentNotInstalled", { task: "disconnect" });
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.DeviceLocked:
                        this.rebootErrorMessage = this.$t("device_status.agentLocked", { task: "disconnect" });
                        this.alertType = "warning";
                        break;
                    case CReqExecutionResultEnum.OperationNotAvailable:
                        this.rebootErrorMessage = this.$t("device_status.operationNotAvailable", { task: "disconnection" });
                        this.alertType = "info";
                        break;
                    case CReqExecutionResultEnum.ServerError:
                        this.rebootErrorMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.InvalidRequest:
                        this.rebootErrorMessage = this.$t("remoteLink.invalidVersion");
                        this.alertType = "error";
                        break;
                    default:
                        console.error("Something went wrong sending Connect request ", error);
                        this.errorMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        break;
                }
            }
            this.stopSessionLoading = false;
        },

        async getAgentTunnelServiceConnectedTime() {
            this.loadingChart = true;
            try {
                let response: GetAgentTunnelServiceConnectedTimeResData = await new GetAgentTunnelServiceConnectedTimeCommand(
                    this.installationName,
                    TunnelProtocolEnum.CService
                ).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString.toLowerCase() == "success") {
                    let values = [];
                    response.last7DaysSessionConnectedTime.forEach((value, date) => {
                        this.dateListString.push(moment(date).format(this.userDateFormat));
                        values.push(value);
                    });
                    if (values.reduce((partialSum, a) => partialSum + a, 0) > 0) this.seriesConnectedTime = [{ name: this.$t("remoteLink.connectedTime"), data: values }];
                    else this.seriesConnectedTime = [];
                } else {
                    throw response.message;
                }
            } catch (error) {
                console.log("Something went wrong sending GetAgentTunnelServiceConnectedTime request ", error);
            }
            this.loadingChart = false;
        },
    },
});
